import {
  DagsterApplicationRunsPage,
  DagsterApplicationRunsPageLoading,
} from '../Platform/PlatformDagsterPage/DagsterApplicationRunsPage'
import { Suspense } from 'react'
import { useCurrentApplication } from './useCurrentApplication'
import { ApplicationsBreadcrumb } from './ApplicationsBreadcrumbs'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'

export function AppDagsterPage() {
  const { applicationId } = useCurrentApplication()
  return (
    <>
      <ApplicationsBreadcrumb title="Dagster" />
      <QueryErrorBoundary errorMessage="Failed to fetch dagster runs">
        <Suspense fallback={<DagsterApplicationRunsPageLoading />}>
          <DagsterApplicationRunsPage appId={applicationId} />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}
